import { ReactNode, useRef, useState } from 'react';
import { Alert, Box, Button, Paper, useTheme } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useTranslation } from 'react-i18next';
import { downloadChartImage } from '../../lib/chartImageExport';

export default function ExportableChart({ title, subtitle, filename, children }: { title: string; subtitle: string; filename: string; children: ReactNode }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const chartRef = useRef<HTMLDivElement>(null);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(false);
  const download = async (format: 'png' | 'svg') => {
    if (!chartRef.current) return;
    setExporting(true);
    setError(false);
    try {
      await downloadChartImage(chartRef.current, title, subtitle, filename, format, theme.palette.background.paper, theme.palette.text.primary);
    } catch {
      setError(true);
    } finally {
      setExporting(false);
    }
  };
  return <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box' }} elevation={1}>
    <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', mb: 1 }}>
      <Button size="small" startIcon={<DownloadIcon />} disabled={exporting} aria-label={t('ui.chartExport.exportChart', { title, format: 'PNG' })} onClick={() => download('png')}>{t('ui.chartExport.savePng')}</Button>
      <Button size="small" disabled={exporting} aria-label={t('ui.chartExport.exportChart', { title, format: 'SVG' })} onClick={() => download('svg')}>SVG</Button>
    </Box>
    {error && <Alert severity="error" sx={{ mb: 1 }}>{t('ui.chartExport.exportFailed')}</Alert>}
    <Box sx={{ overflowX: 'auto' }}><div ref={chartRef} style={{ width: '100%', minWidth: 600 }}>{children}</div></Box>
  </Paper>;
}
